import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Register from "./pages/register"
import RegisterUser from "./pages/registeruser";
import MenuConfig from "./pages/menuconfig";
import ProtectedRoute from "./components/protectedroute";
import VisualizzaComprensori from "./pages/visualizzacomprensori";
import CreaComprensorio from "./pages/creacomprensorio";
import CreaGerarchia from "./pages/creagerarchia";
import VisualizzaGerarchie from "./pages/visualizzagerarchie";
import MenuFruitore from "./pages/menufruitore";
import CreaProposta from "./pages/creaproposta";
import VisualizzaProposte from "./pages/visualizzaproposte";
import VisualizzaInsiemi from "./pages/visualizzainsiemi";


function App() {
  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/registeruser" element={<RegisterUser />} />
      
        <Route path="/menuconfig" element={<ProtectedRoute allowedRoles={["CONFIGURATORE"]}><MenuConfig/></ProtectedRoute>}>
            <Route path="visualizza-comprensori" element={<VisualizzaComprensori />} />
            <Route path="crea-comprensorio" element={<CreaComprensorio />} />
            <Route path="visualizza-gerarchie" element={<VisualizzaGerarchie />} />
            <Route path="crea-gerarchia" element={<CreaGerarchia />} />
            <Route path="visualizza-insiemichiusi" element={<VisualizzaInsiemi />} />
        </Route>

        <Route path="/menufruitore" element={<ProtectedRoute allowedRoles={["FRUITORE"]}><MenuFruitore/></ProtectedRoute>}>
            <Route path="visualizza-gerarchie" element={<VisualizzaGerarchie />} />
            <Route path="crea-proposta" element={<CreaProposta />} />
            <Route path="visualizza-proposte" element={<VisualizzaProposte />} />
        </Route>

      </Routes>
    </Router> 
    </>
  );
}

export default App;
